/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/category-logo': {
    width: 35,
    height: 35,
    viewBox: '0 0 35 35',
    data: '<circle pid="0" cx="17.5" cy="17.5" r="17.5" _fill="#000"/><path pid="1" d="M18.429 20.571V18h-2.572v5.143h2.572v-1.286h5.142V27H18.43v-2.571H14.57V14.143H12V9h5.143v5.143h-1.286v2.571h2.572V15.43h5.142v5.142H18.43z" _fill="#fff"/>'
  }
})
